import React, { Component } from "react";
import AppTable from "../../partials/AppTable";
import LayoutWrapper from "./LayoutWrapper";
import CareerSearch from "./CareerSearch";
import CareerModal from "./CareerModal";
import CareerEditModal from "./CareerEditModal";
import * as imagepaths from "../../../imagepath/imagepath";
import { Switch } from "antd";

export class Career extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct && props.initialconstruct.bind(this)("Career");

    this.state = {
      tableData: [],
      filteredData: null,
      rowcount: 0,
      loader: false,
      editData: null,
      viewMode: false,
      editMode: false,
      modalKey: Date.now(),
      toastMessage: "",
      showToast: false,
      rolesList: [],
      locationsList: [],
      experienceList: [],
      search: {
        page: 1,
        limit: 10,
        orderBy: "updatedAt",
        orderDirection: "DESC",
        role: "",
        location: "",
        createdAtStartDate: "",
        createdAtEndDate: "",
      },
    };

    this.columns = [
      {
        dataIndex: "jobId",
        title: "Job ID",
        render: (text, record) => record.jobId || text || "-",
      },
      {
        dataIndex: "role",
        title: "Role",
        render: (text, record) => record.jobRole || record.role || record.title || text || "-",
      },
      {
        dataIndex: "numberOfPositions",
        title: "Positions",
        render: (text, record) => record.numberOfPositions ?? text ?? "-",
      },
      {
        dataIndex: "location",
        title: "Location",
        render: (text, record) => record.location || text || "-",
      },
      {
        dataIndex: "created_on",
        title: "Created On",
        render: (text, record) => {
          const dateVal = record.createdAt || record.created_on || record.created_at || text;
          if (!dateVal) return "-";
          try {
            if (typeof dateVal === "string" && dateVal.includes("T")) {
              const d = new Date(dateVal);
              if (!isNaN(d.getTime())) {
                const day = String(d.getDate()).padStart(2, "0");
                const month = String(d.getMonth() + 1).padStart(2, "0");
                const year = d.getFullYear();
                return `${day}-${month}-${year}`;
              }
            }
          } catch (e) {}
          return dateVal;
        },
      },
      {
        dataIndex: "state",
        title: "Status",
        render: (text, record) => {
          let val = record.state || record.status;
          if (record.isActive !== undefined) {
            val = record.isActive ? "Active" : "Deactivated";
          }
          if (typeof val === "string") {
            const upper = val.toUpperCase();
            if (upper === "ACTIVE" || upper === "OPEN") val = "Active";
            else if (upper === "DEACTIVATED" || upper === "INACTIVE" || upper === "CLOSED") val = "Deactivated";
          }
          val = val || text || "Active";
          return (
            <span
              className="fw-semibold"
              style={{
                color: val === "Active" ? "#28a745" : "#dc3545",
                fontSize: "14px",
              }}
            >
              {val}
            </span>
          );
        },
      },
    ];
  }

  componentDidMount() {
    this.fetchList();
    this.fetchRoles();
    this.fetchLocations();
    this.fetchExperience();
  }

  extractList = (res, key) => {
    if (!res) return [];
    if (Array.isArray(res)) return res;
    const rawData = res.data !== undefined ? res.data : res;
    if (Array.isArray(rawData)) return rawData;
    if (rawData && typeof rawData === "object") {
      if (Array.isArray(rawData.items) && rawData.items.length > 0) {
        if (Array.isArray(rawData.items[0]?.records)) return rawData.items[0].records;
        return rawData.items;
      }
      if (key && Array.isArray(rawData[key])) return rawData[key];
      if (Array.isArray(rawData.roles)) return rawData.roles;
      if (Array.isArray(rawData.locations)) return rawData.locations;
      if (Array.isArray(rawData.experience)) return rawData.experience;
      if (Array.isArray(rawData.records)) return rawData.records;
      if (Array.isArray(rawData.list)) return rawData.list;
      if (Array.isArray(rawData.data)) return rawData.data;
    }
    if (key && Array.isArray(res[key])) return res[key];
    if (Array.isArray(res.roles)) return res.roles;
    if (Array.isArray(res.locations)) return res.locations;
    if (Array.isArray(res.experience)) return res.experience;
    if (Array.isArray(res.items)) return res.items;
    if (Array.isArray(res.records)) return res.records;
    if (Array.isArray(res.list)) return res.list;
    return [];
  };

  fetchRoles = () => {
    if (this.props.api && this.props.api.apiGetJobRoles) {
      this.props.api
        .apiGetJobRoles()
        .then((res) => {
          const list = this.extractList(res, "roles");
          if (list && list.length > 0) {
            this.setState({ rolesList: list });
          }
        })
        .catch((err) => {
          console.error("Error fetching job roles:", err);
        });
    }
  };

  fetchLocations = () => {
    if (this.props.api && this.props.api.apiGetJobLocations) {
      this.props.api
        .apiGetJobLocations()
        .then((res) => {
          const list = this.extractList(res, "locations");
          if (list && list.length > 0) {
            this.setState({ locationsList: list });
          }
        })
        .catch((err) => {
          console.error("Error fetching job locations:", err);
        });
    }
  };

  fetchExperience = () => {
    if (this.props.api && this.props.api.apiGetJobExperience) {
      this.props.api
        .apiGetJobExperience()
        .then((res) => {
          const list = this.extractList(res, "experience");
          if (list && list.length > 0) {
            this.setState({ experienceList: list });
          }
        })
        .catch((err) => {
          console.error("Error fetching job experience:", err);
        });
    }
  };

  fetchList = () => {
    if (this.props.api && this.props.api.apiGetCareers) {
      this.setState({ loader: true });

      const { search } = this.state;
      const searchObj = {};
      const jobRoleVal = search.role || search.jobRole;
      if (jobRoleVal) {
        searchObj.jobRole = jobRoleVal;
      }
      if (search.location) {
        searchObj.locations = search.location;
      }
      if (search.createdAtStartDate) {
        searchObj.createdAtStartDate = search.createdAtStartDate;
      }
      if (search.createdAtEndDate) {
        searchObj.createdAtEndDate = search.createdAtEndDate;
      }

      const payload = {
        limit: search.limit || 10,
        orderBy: search.orderBy || "updatedAt",
        orderDirection: search.orderDirection || "DESC",
        page: search.page || 1,
        search: searchObj,
      };

      this.props.api
        .apiGetCareers(payload)
        .then((res) => {
          this.setState({ loader: false });
          let list = [];
          let total = 0;

          if (res && res.data) {
            if (Array.isArray(res.data.items) && res.data.items.length > 0) {
              const firstItem = res.data.items[0];
              if (Array.isArray(firstItem?.records)) {
                list = firstItem.records;
              }
              if (Array.isArray(firstItem?.pagination) && firstItem.pagination.length > 0) {
                total = firstItem.pagination[0]?.totalRecords || list.length;
              }
            }

            if (list.length === 0) {
              if (Array.isArray(res.data)) list = res.data;
              else if (Array.isArray(res.data.records)) list = res.data.records;
              else if (Array.isArray(res.data.jobs)) list = res.data.jobs;
              else if (Array.isArray(res.data.list)) list = res.data.list;
              else if (Array.isArray(res.data.data)) list = res.data.data;
              else if (Array.isArray(res.data.rows)) list = res.data.rows;
            }
          }

          if (list.length === 0 && res) {
            if (Array.isArray(res.records)) list = res.records;
            else if (Array.isArray(res.jobs)) list = res.jobs;
            else if (Array.isArray(res.list)) list = res.list;
            else if (Array.isArray(res)) list = res;
          }

          if (total === 0 && res) {
            total =
              res.data?.items?.[0]?.pagination?.[0]?.totalRecords ||
              res.data?.total ||
              res.data?.count ||
              res.data?.totalRecords ||
              res.count ||
              res.total ||
              list.length;
          }

          if (list && list.length > 0) {
            const normalizedList = list.map((item, idx) => {
              const roleName = item.jobRole || item.role || item.title || "";
              const skillsStr = Array.isArray(item.skillsRequired)
                ? item.skillsRequired.join("\n")
                : (item.skills_required || item.skillsRequired || item.skills || "");
              const expStr = Array.isArray(item.experienceRequired)
                ? item.experienceRequired.join("\n")
                : (item.experience_required || item.experienceRequired || item.experience || "");

              let statusState = item.state || item.status;
              if (item.isActive !== undefined) {
                statusState = item.isActive ? "Active" : "Deactivated";
              }
              if (typeof statusState === "string") {
                const upper = statusState.toUpperCase();
                if (upper === "ACTIVE" || upper === "OPEN") statusState = "Active";
                else if (upper === "DEACTIVATED" || upper === "INACTIVE" || upper === "CLOSED") statusState = "Deactivated";
              }
              statusState = statusState || "Active";

              return {
                ...item,
                _id: item._id || item.id || item.jobId || `job_${idx}`,
                jobId: item.jobId || "",
                role: roleName,
                jobRole: item.jobRole || roleName,
                job_description: item.description || item.job_description || "",
                description: item.description || item.job_description || "",
                skills_required: skillsStr,
                skillsRequired: item.skillsRequired || skillsStr,
                experience_required: expStr,
                experienceRequired: item.experienceRequired || expStr,
                numberOfPositions: item.numberOfPositions ?? 1,
                enrolled: item.enrolled ?? 0,
                location: item.location || "-",
                created_on: item.createdAt || item.created_on || "",
                createdAt: item.createdAt || item.created_on || "",
                updatedAt: item.updatedAt || "",
                state: statusState,
                isActive: item.isActive !== undefined ? item.isActive : statusState === "Active",
              };
            });

            this.setState({
              tableData: normalizedList,
              filteredData: null,
              rowcount: total,
            });
          } else {
            this.setState({
              tableData: [],
              filteredData: null,
              rowcount: 0,
            });
          }
        })
        .catch((err) => {
          console.error("Error fetching careers list:", err);
          this.setState({ loader: false });
        });
    }
  };

  triggerToast = (msg) => {
    this.setState({ toastMessage: msg, showToast: true });
    if (window.success) window.success(msg);
    setTimeout(() => {
      this.setState({ showToast: false });
    }, 4000);
  };

  onSearchChange = (filters) => {
    const { role, location, createdAtStartDate, createdAtEndDate } = filters;
    this.setState(
      {
        search: {
          ...this.state.search,
          page: 1,
          role: role || "",
          location: location || "",
          createdAtStartDate: createdAtStartDate || "",
          createdAtEndDate: createdAtEndDate || "",
        },
      },
      () => this.fetchList()
    );
  };

  onPageChange = (pageData) => {
    this.setState(
      {
        search: {
          ...this.state.search,
          page: pageData.current,
          limit: pageData.pageSize || 10,
        },
      },
      () => this.fetchList()
    );
  };

  openAddModal = () => {
    this.setState({ editMode: false, viewMode: false, editData: null, modalKey: Date.now() });
  };

  editAction = (record) => {
    const jobId = record.jobId || record._id;
    if (!jobId) return;

    const apiBase = window.envconfig?.[window.environment]?.api_base || window.axios?.defaults?.baseURL || "https://devapi.cognospace.in";
    let token = window.store?.getState()?.root?.auth || localStorage.getItem("token") || localStorage.getItem("auth") || "";
    if (token) {
      token = token.trim();
      if (!token.toLowerCase().startsWith("bearer ")) {
        token = `Bearer ${token}`;
      }
    }
    const headers = {
      ...(token ? { Authorization: token } : {}),
      "Content-Type": "application/json",
    };

    fetch(`${apiBase}/api/v1/jobs/${jobId}`, { method: "GET", headers })
      .then((r) => r.json())
      .then((res) => {
        let detailedData = record;
        if (res && res.data) {
          detailedData = { ...record, ...res.data };
        } else if (res && !res.error && res.jobId) {
          detailedData = { ...record, ...res };
        }
        
        if (Array.isArray(detailedData.location)) {
          detailedData.location = detailedData.location.join(", ");
        }

        this.setState(
          {
            editMode: true,
            viewMode: false,
            editData: detailedData,
            modalKey: Date.now(),
          },
          () => {
            document.querySelector("#career_edit_modal_trigger")?.click();
          }
        );
      })
      .catch((err) => {
        console.error("Error fetching job details:", err);
        // Fallback to record
        this.setState(
          {
            editMode: true,
            viewMode: false,
            editData: record,
            modalKey: Date.now(),
          },
          () => {
            document.querySelector("#career_edit_modal_trigger")?.click();
          }
        );
      });
  };

  viewAction = (record) => {
    this.setState(
      {
        editMode: false,
        viewMode: true,
        editData: record,
        modalKey: Date.now(),
      },
      () => {
        document.querySelector("#career_edit_modal_trigger")?.click();
      }
    );
  };

  toggleStatusAction = (record) => {
    const newStatus = record.state === "Active" ? "Deactivated" : "Active";
    const updatedTableData = this.state.tableData.map((item) =>
      item._id === record._id ? { ...item, state: newStatus } : item
    );
    const updatedFilteredData = this.state.filteredData
      ? this.state.filteredData.map((item) =>
        item._id === record._id ? { ...item, state: newStatus } : item
      )
      : null;

    this.setState({
      tableData: updatedTableData,
      filteredData: updatedFilteredData,
    });

    this.triggerToast(`Job ${newStatus === "Active" ? "activated" : "deactivated"} successfully`);
  };

  deleteAction = (record) => {
    if (this.props.api && this.props.api.apiDeleteCareer) {
      this.props.api.apiDeleteCareer(null, { career_id: record._id }).then(() => {
        this.triggerToast("Job deleted successfully");
        this.fetchList();
      }).catch(console.error);
    } else {
      const updatedTableData = this.state.tableData.filter(item => item._id !== record._id);
      const updatedFilteredData = this.state.filteredData ? this.state.filteredData.filter(item => item._id !== record._id) : null;
      this.setState({
        tableData: updatedTableData,
        filteredData: updatedFilteredData,
        rowcount: updatedTableData.length
      });
      this.triggerToast("Job deleted successfully");
    }
  };

  handleModalSubmit = (e, formData) => {
    e.preventDefault();
    const { editMode, editData, tableData } = this.state;

    if (editMode && editData) {
      // Edit existing job
      const payload = {
        jobRole: formData.role !== undefined ? formData.role : "",
        description: formData.job_description !== undefined ? formData.job_description : "",
        skillsRequired: formData.skills_required ? String(formData.skills_required).split('\n').map(s => s.trim()).filter(Boolean) : [],
        experienceRequired: formData.experience_required ? String(formData.experience_required).split('\n').map(s => s.trim()).filter(Boolean) : [],
        location: formData.location ? String(formData.location).split('\n').map(s => s.trim()).filter(Boolean) : [],
        isActive: formData.status === "Active"
      };

      if (this.props.api && this.props.api.apiUpdateCareer) {
        this.props.api.apiUpdateCareer(payload, { career_id: editData._id }).then((res) => {
          document.querySelector("#career_edit_modal #bsmodalclose")?.click();
          this.triggerToast("Job updated successfully");
          this.fetchList();
        }).catch((err) => {
          console.error(err);
        });
      } else {
        const updatedList = tableData.map((item) => {
          if (item._id === editData._id) {
            return {
              ...item,
              role: formData.role || item.role,
              job_description: formData.job_description || item.job_description,
              skills_required: formData.skills_required || item.skills_required,
              experience_required: formData.experience_required || item.experience_required,
              location: formData.location || item.location,
              numberOfPositions: formData.number_of_positions || item.numberOfPositions,
              state: formData.status || item.state,
            };
          }
          return item;
        });

        this.setState({
          tableData: updatedList,
          filteredData: this.state.filteredData ? updatedList : null,
          rowcount: updatedList.length,
          modalKey: Date.now(),
        });

        document.querySelector("#career_edit_modal #bsmodalclose")?.click();
        this.triggerToast("Job updated successfully");
      }
    } else {
      // Add new job
      const payload = {
        jobRole: formData.role !== undefined ? formData.role : "",
        description: formData.job_description !== undefined ? formData.job_description : "",
        skillsRequired: formData.skills_required ? String(formData.skills_required).split('\n').map(s => s.trim()).filter(Boolean) : [],
        experienceRequired: formData.experience_required ? String(formData.experience_required).split('\n').map(s => s.trim()).filter(Boolean) : [],
        location: formData.location ? String(formData.location).split('\n').map(s => s.trim()).filter(Boolean) : [],
        numberOfPositions: formData.number_of_positions ? Number(formData.number_of_positions) : 1
      };

      if (this.props.api && this.props.api.apiCreateCareer) {
        this.props.api.apiCreateCareer(payload).then((res) => {
          document.querySelector("#career_modal #bsmodalclose")?.click();
          this.triggerToast("Job added successfully");
          this.fetchList();
        }).catch((err) => {
          console.error(err);
        });
      } else {
        // Fallback if api is not available
        const newJob = {
          _id: String(Date.now()),
          role: payload.jobRole,
          location: payload.location,
          created_on: new Date().toLocaleDateString("en-GB").replace(/\//g, "-"),
          state: "Active",
          job_description: payload.description,
          skills_required: payload.skillsRequired,
          experience_required: payload.experienceRequired,
          numberOfPositions: payload.numberOfPositions
        };

        const newList = [newJob, ...tableData];
        this.setState({
          tableData: newList,
          filteredData: this.state.filteredData ? newList : null,
          rowcount: newList.length,
          modalKey: Date.now(),
        });

        document.querySelector("#career_modal #bsmodalclose")?.click();
        this.triggerToast("Job added successfully");
      }
    }
  };

  render() {
    const { tableData, filteredData, rowcount, loader, editData, viewMode, editMode, showToast, toastMessage, rolesList, locationsList, experienceList } = this.state;
    const displayData = filteredData !== null ? filteredData : tableData;

    // Dynamically combine roles from rolesList and tableData items
    const tableRoles = (tableData || []).map((item) => item.jobRole || item.role).filter(Boolean);
    const combinedRoles = Array.from(
      new Set([
        ...rolesList.map((r) => (typeof r === "string" ? r : (r.jobRole || r.role || r.name || r.value || ""))),
        ...tableRoles,
      ])
    ).filter(Boolean);

    // Dynamically combine locations from locationsList and tableData items
    const tableLocations = (tableData || []).map((item) => item.location).filter(Boolean);
    const combinedLocations = Array.from(
      new Set([
        ...locationsList.map((l) => (typeof l === "string" ? l : (l.location || l.name || l.value || ""))),
        ...tableLocations,
      ])
    ).filter(Boolean);

    return (
      <LayoutWrapper 
        title="Career" 
        back=""
        headerRight={
          <button
            type="button"
            className="btn text-white fw-bold px-3 d-flex align-items-center justify-content-center"
            style={{
              backgroundColor: "#f39c12",
              color: "white",
              borderRadius: "8px",
              height: "42px",
              whiteSpace: "nowrap",
            }}
            data-bs-toggle="modal"
            data-bs-target="#career_modal"
            onClick={this.openAddModal}
          >
            <i className="fa fa-plus me-1"></i> Add New
          </button>
        }
      >
        {/* Floating Success Toast Banner */}
        {showToast && (
          <div
            className="toast-container position-fixed top-0 end-0 p-3"
            style={{ zIndex: 9999, marginTop: "70px" }}
          >
            <div
              className="toast show align-items-center text-white border-0 p-2 shadow-lg"
              role="alert"
              aria-live="assertive"
              aria-atomic="true"
              style={{
                backgroundColor: "#00875a",
                borderRadius: "10px",
                minWidth: "320px",
              }}
            >
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center px-2">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center me-3"
                    style={{
                      width: "32px",
                      height: "32px",
                      backgroundColor: "white",
                      color: "#00875a",
                    }}
                  >
                    <i className="fa fa-check fw-bold"></i>
                  </div>
                  <span className="fw-semibold" style={{ fontSize: "15px" }}>
                    {toastMessage || "Job added successfully"}
                  </span>
                </div>
                <button
                  type="button"
                  className="btn-close btn-close-white me-2 shadow-none"
                  onClick={() => this.setState({ showToast: false })}
                ></button>
              </div>
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-12">
            {/* Search Filters */}
            <CareerSearch
              roles={combinedRoles}
              locations={combinedLocations}
              onSearch={this.onSearchChange}
            />

            {/* AppTable Component matching category.jsx & enquires.jsx */}
            <div className="card bg-white p-3 shadow-sm border-0" style={{ borderRadius: "12px" }}>
              <AppTable
                data={displayData}
                columns={this.columns}
                total={rowcount}
                loading={loader}
                onChange={(...arg) => this.onPageChange(...arg)}
                isCustomRowKey={true}
                customRowKey="_id"
                reorder={true}
                viewable={true}
                editable={true}
                deletable={true}
                deleteAction={(v) => this.deleteAction(v)}

                editAction={(v) => this.editAction(v)}
                viewAction={(v) => this.viewAction(v)}
                targetType="tap"
                isresponsive={true}
              />
            </div>
          </div>
        </div>

        {/* Add New Job Modal */}
        <CareerModal
          id="career_modal"
          modalKey={this.state.modalKey}
          title="Add New Job"
          submitText="Save"
          roles={combinedRoles}
          locations={combinedLocations}
          experience={experienceList}
          onSubmit={this.handleModalSubmit}
          api={this.props.api}
          onClose={() =>
            this.setState({ editData: null, editMode: false, viewMode: false, modalKey: Date.now() })
          }
        />

        {/* Edit/View Job Modal Trigger */}
        <button
          id="career_edit_modal_trigger"
          className="d-none"
          data-bs-toggle="modal"
          data-bs-target="#career_edit_modal"
        ></button>

        {/* Edit/View Job Modal */}
        <CareerEditModal
          id="career_edit_modal"
          modalKey={this.state.modalKey}
          title={viewMode ? "View Job Details" : "Edit Job Details"}
          submitText="Save"
          roles={combinedRoles}
          locations={combinedLocations}
          experience={experienceList}
          editdata={editData}
          editMode={editMode}
          viewMode={viewMode}
          onSubmit={this.handleModalSubmit}
          api={this.props.api}
          onClose={() =>
            this.setState({ editData: null, editMode: false, viewMode: false, modalKey: Date.now() })
          }
        />
      </LayoutWrapper>
    );
  }
}

export default connect(Career);
